import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export const faCircle: IconDefinition = {
  prefix: "fas",
  iconName: "circle",
  icon: [512, 512, [], "f111", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"],
};

export default faCircle;
